import type { WizardStepStatus } from '@/types/Wizard.types';

export function resolveWizardStepStatus(params: {
  wizardStepNumber: number;
  currentWizardStepNumber: number;
}): WizardStepStatus {
  const { wizardStepNumber, currentWizardStepNumber } = params;

  if (wizardStepNumber === currentWizardStepNumber) return 'current';
  if (wizardStepNumber < currentWizardStepNumber) return 'completed';
  return 'upcoming';
}
